import React from "react";

class RankLevelIcon extends React.Component {
  render() {
    const level = this.props.rank_level ?? "unranked";

    return (
      <img
        className="rank-icon"
        src={`https://aoeitalia.com/aoe4/ranks/${level}.png`}
        alt={`Rank ${level}`}
        title={level}
      />
    );
  }
}

export default RankLevelIcon;